<template>
  <div class="container-material hold mt-7">
    <div v-show="this.$router.currentRoute.name !== 'welcome-setup' " class="user">
      <div class="user--details">
        <span>Click <a href="#" style="color: #639440;" @click.prevent="preview"> here </a> to Preview your profile.</span><br>
        <span class="pb-2 mb-2">Go back to Welcome Page by clicking  <router-link style="color:#639440" :to="{ name: 'welcome-setup' }">Here</router-link> </span>
      </div>
      <div class="user--progress">
        <p style="padding: 0;">Verification Status: <span style="margin-left: 15px; float: right;" class="badge new" :class="{danger: (!u.verified)}">{{ this.u.verified ? 'Verified' : 'Unverified' }}</span></p>
        Completed {{ steps }} of 5 steps | Next Step: {{s[steps+1]}} <span class="hide-on-med-and-up">Tutor ID: {{ u.former_id }}</span>
        <div class="progress-bar">
          <div class="bar" :style="{ width: `${width}%` }"></div>
        </div>
      </div>
    </div>
    <div class="steps hide-on-med-and-up">
      <h3>Tutor signup steps</h3>
      <div class="steps-nav">
        <!-- <div class="steps-nav--item" ref="setup" :class="{ active: ac([ 'setup' ]) }">
          <p>1</p>
          <span><router-link :to="{ name: 'welcome-setup' }">Tutor Onboard</router-link></span>
        </div> -->
        <div class="steps-nav--item" ref="basic" :class="{ active: ac([ 'basic' ]) }">
          <p>1</p>
          <span><router-link :to="{ name: 'basic-setup' }">Personal Information</router-link></span>
        </div>
        <div class="steps-nav--item" ref="education" :class="{ active: ac([ 'education' ]) }">
          <p>2</p>
          <span><router-link :to="{ name: 'education-setup' }" :class="{ disabled: !(u.steps && u.steps.personal_info) }">Educational Background</router-link></span>
        </div>
        <div class="steps-nav--item" ref="verification" :class="{ active: ac([ 'verification' ]) }">
          <p>3</p>
          <span><router-link :to="{ name: 'verification-setup' }" :class="{ disabled: !(u.steps && u.steps.educational_background) }">Verification</router-link></span>
        </div>
        <div class="steps-nav--item" ref="academic_info" :class="{ active: ac([ 'tutoring-info' ]) }">
          <p>4</p>
          <span><router-link :to="{ name: 'availability-info' }" :class="{ disabled: !((u.steps && u.steps.verification) && u.verified) }">Tutoring Information</router-link></span>
        </div>
        <div class="steps-nav--item" ref="how_it_works" :class="{ active: ac([ 'how-it-works' ]) }">
          <p>5</p>
          <span><router-link :to="{ name: 'how-it-works-setup' }" :class="{ disabled: !(u.steps && u.steps.academic_info) }">How it Works</router-link></span>
        </div>
      </div>
    </div>
    <!-- <div class="alert alert-dark" role="alert">
      <b>Dear Tutor, kindly note that Prepclass is only hiring Full-Time Teachers, interested in working full-time with prepclass, please register your details <a href="http://bit.ly/tutorapplication3">here</a></b>
    </div> -->
    <div class="notification-alert alert" :class="notificationType(notification.type)" role="alert" v-for="notification of nots.filter(n => !n.read)" :key="notification.id">
      <span v-html="notification.content"></span>
      <span style="cursor: pointer; float: right;" @click="removeNotification(notification.id)"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Capa_1" x="0px" y="0px" viewBox="0 0 212.982 212.982" style="enable-background:new 0 0 212.982 212.982;" xml:space="preserve" width="9px" height="9px"><g id="Close"><path style="fill-rule:evenodd;clip-rule:evenodd;" d="M131.804,106.491l75.936-75.936c6.99-6.99,6.99-18.323,0-25.312   c-6.99-6.99-18.322-6.99-25.312,0l-75.937,75.937L30.554,5.242c-6.99-6.99-18.322-6.99-25.312,0c-6.989,6.99-6.989,18.323,0,25.312   l75.937,75.936L5.242,182.427c-6.989,6.99-6.989,18.323,0,25.312c6.99,6.99,18.322,6.99,25.312,0l75.937-75.937l75.937,75.937   c6.989,6.99,18.322,6.99,25.312,0c6.99-6.99,6.99-18.322,0-25.312L131.804,106.491z" fill="#721c24"/></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g></svg></span>
    </div>
    <div class="content">
      <router-view @notify="notify"></router-view>
    </div>
    <div class="footer">
      <span>If you experience any issues, &nbsp;<a href="https://docs.google.com/forms/d/e/1FAIpQLScWBN0KREUpTmh3zePNM9XHVwYCSNbEmgaYpTww7autVig4NQ/viewform" target="_blank">Click here</a></span>
      <span class="hide-on-small-only">&nbsp; to fill &nbsp;<a href="https://docs.google.com/forms/d/e/1FAIpQLScWBN0KREUpTmh3zePNM9XHVwYCSNbEmgaYpTww7autVig4NQ/viewform" target="_blank"> our complaint form</a>. We will address it and get back to you.</span>
    </div>
    <!-- <pre>{{ width }}</pre> -->
  </div>
</template>

<script>
import axios from 'axios';
import moment from 'moment';
import swal from 'sweetalert';
import momentzone from 'moment-timezone';
import StepsNav from './partials/StepsNav';

export default {
  name: 'setup-index',
  components: { StepsNav },
  data() {
    return {
      user: this.$auth.user(),
      s: [
        'Personal Information',
        'Educational Background',
        'Verification',
        'Academic Information',
        'How It Works',
      ],
      e: [
        'Fill out your profile',
        'Tell us about your educational background',
        'We need some identification',
        'Select your subjects',
        'Be sure you know what\'s up',
      ],
      rou: [
        'basic-setup',
        'education-setup',
        'verification-setup',
        'availability-info',
        'how-it-works-setup',
      ],
      nots: [],
      r: [],
    };
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (vm.$auth.user().has_active_classes) {
        return vm.$router.push({ name: 'home-dashboard' });
      }

      if (Object.values(vm.$auth.user().steps).length >= 5) {
        return axios.get(`${BASE_API}/v1/tutor/${vm.$auth.user().id}/passed-test`)
          .then(({ data: { status } }) => {
            if (status) {
              return vm.$router.push({ name: 'home-dashboard' });
            }
            return true;
          })
          .catch(error => false);
      }
      return true;
    });
  },
  computed: {
    u() {
      return this.$auth.user();
    },
    steps() {
      if (this.u.steps) {
        return Object.values(this.u.steps).filter(v => v).length;
      }
      return 0;
    },
    width() {
      return (this.steps * 100) / 5;
    },
  },
  methods: {
    toUsername(val) {
      return val.toLowerCase().replace(' ', '.');
    },
    removeNotification(id) {
      const nots = this.r.findIndex(n => n.id === id);
      this.r[nots].read = true;
      this.nots.splice(nots, 1);
      const notifications = [];

      for (let notification of this.r) {
        notifications.push(notification);
      }

      this.$store.dispatch('updateNotifications', notifications)
        .then(response => console.log(response))
        .catch(response => swal('Failed', response, 'error'));
    },
    notificationType(t) {
      switch (t) {
        case 'error':
          return 'alert-danger';

        case 'info':
          return 'alert-info';

        case 'warn':
          return 'alert-warning';

        default:
          return 'alert-danger';
      }
    },
    ac(input) {
      const paths = Array.isArray(input) ? input : [input];
      return paths.some(path => this.$route.path.indexOf(path) >= 0);
    },
    createNotification() {
      const notification = {
        id: Math.floor((Math.random() * 100000) + 1),
        read: false,
        type: 'info',
        content: `You were just verified, To move to the next stage <router-link :to="{ name: 'verification-setup' }">click here</router-link>`,
        created_at: {
          date: moment().format('YYYY-MM-DD HH:mm:ss'),
          timezone: momentzone.tz.guess(),
          timezone_type: 3
        },
        created_by: 'SYSTEM',
      };

      this.r.push(notification);
      this.nots.push(notification);
    },
    resendEmail() {
      axios.post(`${BASE_API}/v1/tutor/verify_email/resend`, {
        action: 'resend-verification',
      })
        .then(() => swal('Verification Email sent'))
        .catch(() => swal('Failed to send verification email. Please Try again later.'));
    },
    notify(notification) {
      if (this.nots.filter(n => n.flag === 're-edit-warn' && n.read === false).length > 0) {
        return false;
      }
      this.r.push(notification);
      return this.nots.push(notification);
    },
    listen() {
      Echo.channel(`tutor-${this.$auth.user().id}-verified`)
        .listen('TutorVerified', ({ tutor }) => {
          this.$auth.fetch();
          const notification = {
            id: Math.floor((Math.random() * 100000) + 1),
            read: false,
            type: 'info',
            content: 'You were just verified, To move to the next stage go to the verifications page and save.',
            created_at: {
              date: moment().format('YYYY-MM-DD HH:mm:ss'),
              timezone: momentzone.tz.guess(),
              timezone_type: 3
            },
            created_by: 'SYSTEM',
          };

          this.r.push(notification);
          this.nots.push(notification);
        });
      Echo.channel(`tutor-${this.$auth.user().id}-notifications`)
        .listen('NewNotification', ({notification}) => {
          this.r.push(notification);
          this.nots.push(notification);
        });
    },
    preview() {
      return this.$router.push({
        name: 'preview-profile',
        params: {
          tutor: this.$auth.user().id
        },
        query: {
          redirect: window.location.href
        }
      });
    },
    scrollInto() {
      if (this.$route.path.indexOf('basic') >= 0) {
        this.$nextTick(() => {
          this.$refs.basic.scrollIntoView({
            behavior: 'smooth', block: 'center', inline: 'center',
          });
        });
      }

      if (this.$route.path.indexOf('education') >= 0) {
        this.$nextTick(() => {
          this.$refs.education.scrollIntoView({
            behavior: 'smooth', block: 'center', inline: 'center',
          });
        });
      }

      if (this.$route.path.indexOf('verification') >= 0) {
        this.$nextTick(() => {
          this.$refs.verification.scrollIntoView({
            behavior: 'smooth', block: 'center', inline: 'center',
          });
        });
      }

      if (this.$route.path.indexOf('academic_info') >= 0) {
        this.$nextTick(() => {
          this.$refs.academic_info.scrollIntoView({
            behavior: 'smooth', block: 'center', inline: 'center',
          });
        });
      }

      if (this.$route.path.indexOf('how_it_works') >= 0) {
        this.$nextTick(() => {
          this.$refs.how_it_works.scrollIntoView({
            behavior: 'smooth', block: 'center', inline: 'center',
          });
        });
      }
    },
  },
  mounted() {
    console.log(this.$router.currentRoute);
    this.$store.dispatch('getUserTutor');
    for (let n of  this.$auth.user().notifications) {
      this.r.push(n);
      this.nots.push(n);
    }


    if (this.steps) {
      if (this.$route.name !== 'test-status') {
        this.$router.push({ name: this.rou[this.steps] });
      }
    }

    this.listen();
  },
  updated() {
    this.scrollInto();
  },
};
</script>

<style lang="scss" scoped>
* {
  box-sizing: border-box;
}
.hold {
  padding: 10px 0;
}
.notification-alert {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}
.mt-7 { margin-top: 4rem;}
.user {
  margin-top: 15px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  .user--details {
    width: 60%;
    h1 {
      margin: 0;
      font-weight: 800;
      font-size: 30px;
      text-transform: capitalize;
      margin: 10px 0;
      text-align: left;
    }
    p {
      margin: 5px 0;
    }
    span {
      font-size: 14px;
    }
  }
  .user--progress {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    font-size: 14px;
    color: #2A2A2A;
    width: 35%;
    .progress-bar {
      margin: 3px;
      width: 100%;
      height: 5px;
      border-radius: 50%;
      background-color: #F0F2F8;
      .bar {
        height: 100%;
        min-width: 20px;
        border-radius: 10px;
        background-color: #639440;
      }
    }
    span {
      font-size: 14px;
      font-weight: 600;
      a {font-size: 12px;  font-style: italic;}
    }
  }
}
.steps {
  margin: 35px 0;
  h3 {
    font-size: 20px;
    font-weight: 800;
    margin: 10px 0;
  }
}
.steps-nav {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  margin: 25px 0;
  .steps-nav--item {
    width: 220px;
    height: 90px;
    background-color: #F0F2F8;
    padding: 17px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    margin-right: 30px;
    p { width: 30%; font-size: 78px; color: #4D4F5C; line-height: 78px; margin: 0; font-weight: 200; }
    span a { display: inline-block; width: 70%; padding: 10px; font-size: 16px; color: #4D4F5C;}
    &.active { background-color: #639440; p {color: #ffffff;} span a {color: #ffffff;}}
  }
}
.content {
  width: 100%;
  margin: 0;
}
.footer {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  width: 100%;
  background-color: lighten(#202030, 10%);
  padding: 25px;
  margin-top: 40px;
  color: #ffffff;
}

@media only screen and (max-width: 600px) {
  .user {
    margin-top: 0px;
    flex-direction: column;
    .user--details {
      width: 100%;
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      h1 {
        font-size: 18px;
        min-width: 100%;
      }
      p {font-size: 11px; margin-right: 10px;}
    }
    .user--progress {
      width: 100%;
      font-size: 12px;
      .progress-bar {
        height: 14px;
        border-radius: 7px;
        .bar {
          min-width: 14px;
          border-radius: 7px;
        }
      }
      span {
        font-size: 10px;
      }
    }
  }
  .steps {
    margin: 15px 0;
    h3 {
      font-size: 16px;
      font-weight: 800;
      margin: 8px 0;
    }
  }
  .footer {
    // display: none;
    flex-direction: column;
    margin-top: 0px;
    margin-bottom: 60px;
    padding: 8px 15px;
    width: fit-content;
    font-size: 12px;
    font-weight:400;
    border-radius: 25px;
    background: white;
    color: #576271;
    box-shadow: 0 8px 17px 2px rgba(200, 200, 200, 0.14), 0 3px 14px 2px rgba(200, 200, 200, 0.12), 0 5px 5px -3px rgba(200, 200, 200, 0.2);
  }
  .steps-nav {
    overflow: hidden;
    overflow-x:auto;
    margin: 15px 0;
    .steps-nav--item {
      width: 190px;
      height: 75px;
      padding: 13px;
      margin-right: 20px;
      p {font-size: 60px;}
      span a { font-size: 12px;}
    }
  }
  .content {
    margin: 0;
  }
}
span.badge {
    min-width: 3rem;
    padding: 0 14px;
    text-align: center;
    font-size: 1rem;
    line-height: 22px;
    height: 22px;
    box-sizing: border-box;
    text-transform: lowercase;

    &.new {
      font-weight: 300;
      font-size: 0.8rem;
      color: #fff;
      background-color: #539987;
      border-radius: 2px;

      &.danger {
        background-color: #F4507C;
      }
    }

    &[data-badge-caption]::after {
      content: " " attr(data-badge-caption);
    }
  }

  // Special cases
  nav ul a span.badge {
    display: inline-block;
    float: none;
    margin-left: 4px;
    line-height: 22px;
    height: 22px;
    -webkit-font-smoothing: auto;
  }

  table span.badge {
    display: inline-block;
    float: none;
    margin-left: auto;
  }
</style>


// WEBPACK FOOTER //
// src/components/Pages/Setup/Index.vue